import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './configureStore';

export interface AssignmentState {
    computer: number;
    initiated: boolean;
}
const initialState: AssignmentState = {
    computer: -1,
    initiated: false,
};

export const assignmentSlice = createSlice({
    name: 'assignmentSlice',
    initialState,
    reducers: {
        setInitiated: (state, action: PayloadAction<boolean>) => {
            state.initiated = action.payload;
        },
        setComputer: (state, action: PayloadAction<number>) => {
            state.computer = action.payload;
        },
        reset: (state) => {
            state.computer = -1;
            state.initiated = false;
        },
    },
});

export const selectState = (state: RootState) => state.assignmentSlice;
export const selectComputer = createSelector(selectState, (state) => state.computer);
export const selectInitiated = createSelector(selectState, (state) => state.initiated);

export const { setInitiated, setComputer, reset } = assignmentSlice.actions;
